import React from 'react'
import { Link } from "react-router-dom";

// components
import Datos from 'components/fanpageWebhook'
import MetaTags from 'components/metatags'

const DatosPage = () => (
    <>
        <MetaTags title='Datos recientes' description='Datos recientes de páginas' />
        <Datos />
    </>
)

export default DatosPage
